import { lazy } from 'react';

//sets the pages display settings
const GraduationConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/graduation/:code',
      component: lazy(() => import('./Graduation')),
    },
  ],
};

export default GraduationConfig
